<template>
  <main>
    <div
      class="swiper swiper-container banner-swiper"
      v-if="bannerConfigList.length > 1"
    >
      <div class="swiper-wrapper">
        <a
          class="swiper-slide"
          v-for="(item, index) in bannerConfigList"
          :key="index"
          :href="getActivityLink(item.link)"
          target="_blank"
          :pointValue="item.link"
        >
          <img class="slide-img" :class="[lang, item.class]" />
        </a>
      </div>
      <div class="swiper-pagination"></div>
    </div>
    <div
      v-else
      class="banner"
      :class="[lang, bannerClass]"
      @click="handleJumpLink"
    ></div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import globalConfig from '@utiles/officialStore/globalConfig';
import Swiper from 'swiper';
import openActivity, { BANNER_ACTIVITY } from '@utiles/openActivity';
import { getGlobalGetLinkParams } from '@utiles/globalGetLink';
export default {
  name: 'Banner',
  computed: {
    ...mapGetters(['gameInfoConfig']),
    gameId() {
      return this.$store.state.gameId;
    },
    lang() {
      return this.$store.state.lang;
    },
    isShowNewBanner() {
      return this.gameInfoConfig.topBannerSwiper?.length > 0;
    },
    bannerImg() {
      return this.gameInfoConfig.topBannerSwiper;
    },
    bannerConfigList() {
      const bannerConfigMaps = {
        285: [
          {
            class: 'dtmslg-swiper2',
            link: `https://auto-page.${globalConfig.getMainHost()}/k1_Augopscamp/`,
            isLimitTime: true,
            startTime: '2025-08-20T23:59:59Z',
            endTime: '2025-09-03T23:59:59Z'
          },
          {
            class: 'dtmslg-swiper1',
            link: `https://auto-page.${globalConfig.getMainHost()}/k1longtermtopup/`,
            isLimitTime: true,
            startTime: '2024-12-31T23:59:59Z',
            endTime: '2028-12-31T23:59:59Z'
          }
        ]
      };
      let bannerConfig = [];
      if (bannerConfigMaps.hasOwnProperty(+this.gameId)) {
        bannerConfigMaps[+this.gameId].forEach(item => {
          if (item.isLimitTime) {
            const currentUTCTime = new Date().toISOString();
            // 以UTC+0时间为准，判断当前时间是否在活动结束时间之前
            if (
              item.startTime < currentUTCTime &&
              currentUTCTime < item.endTime
            ) {
              bannerConfig.push(item);
            }
          } else {
            bannerConfig.push(item);
          }
        });
      }
      return bannerConfig;
    },
    // 限时活动统一处理展示逻辑
    bannerClass() {
      // 以UTC+0时间为准，判断当前时间是否在活动结束时间之前
      const currentUTCTime = new Date().toISOString();
      // 限时活动开始时间
      const targetStartTimeMaps = {
        191: '2025-07-15T23:59:59Z'
      };
      // 限时活动结束时间
      const targetTimeMaps = {
        209: '2024-11-10T14:59:59Z', // 相当于日本时间2024-11-10 23:59:59
        211: '2024-11-10T14:59:59Z', // 相当于韩国时间2024-11-10 23:59:59
        263: '2025-07-18T23:59:59Z',
        285: '2028-12-31T23:59:59Z',
        191: '2040-07-15T23:59:59Z'
      };
      if (targetTimeMaps.hasOwnProperty(+this.gameId)) {
        if (
          (targetStartTimeMaps[+this.gameId] || '2000-01-01T23:59:59Z') <
            currentUTCTime &&
          currentUTCTime < targetTimeMaps[+this.gameId]
        ) {
          if (+this.gameId === 209) {
            return 'dzg-jp';
          }
          if (+this.gameId === 211) {
            return 'dzg-kr';
          }
          if (+this.gameId === 263) {
            return 'antslg-en';
          }
          if (+this.gameId === 285) {
            return 'dtmslg-en';
          }
          if (+this.gameId === 191) {
            const langClass = {
              'en-US': 'ztmslg-en',
              'de-DE': 'ztmslg-de',
              'ko-KR': 'ztmslg-ko',
              'ru-RU': 'ztmslg-ru'
            };
            return langClass[this.lang] || langClass['en-US'];
          }
        }
      }
      return '';
    }
  },
  methods: {
    initSwiper() {
      try {
        new Swiper('.banner-swiper', {
          loop: true,
          autoplay: {
            delay: 4000,
            stopOnLastSlide: false,
            disableOnInteraction: false
          },
          direction: 'horizontal',
          pagination: {
            el: '.swiper-pagination'
          },
          effect: 'slide',
          observer: true,
          observeParents: true
        });
      } catch (e) {
        console.log(e);
      }
    },
    jumpLink(link) {
      openActivity(BANNER_ACTIVITY, link, {
        language: this.lang,
        appLanguage: this.lang,
        ...getGlobalGetLinkParams()
      });
    },
    getActivityLink(activityUrl) {
      if (!activityUrl) return '';
      // 判断是不是pwa
      const boolPwa = globalConfig.getHrefParam('mode') === 'pwa';
      let payCid = '';
      let payScid = '';
      if (boolPwa) {
        try {
          const localPwaActivityCidStr =
            window.localStorage.getItem('pwaActivityScid');
          const localPwaActivityCidObj = JSON.parse(localPwaActivityCidStr);
          payCid = localPwaActivityCidObj?.cid || '';
          payScid = localPwaActivityCidObj?.scid || '';
        } catch (e) {
          console.error(e);
        }
      } else {
        payCid = globalConfig.getHrefParam('cid');
        payScid = globalConfig.getHrefParam('scid');
      }
      let activityCid = payCid;
      let activityScid = '';
      activityScid = payScid
        ? `${payScid}_${BANNER_ACTIVITY}`
        : BANNER_ACTIVITY;
      let link = activityUrl;
      let obj = {
        cid: activityCid,
        scid: activityScid,
        language: this.lang,
        appLanguage: this.lang,
        ...getGlobalGetLinkParams()
      };
      let newUrl = '';
      try {
        // 判断是否有加https或者http协议
        if (!(link.startsWith('http:') || link.startsWith('https:'))) {
          link = (window?.location?.protocol || 'https:') + link;
        }
        let url = new URL(link);
        for (let k in obj) {
          url.searchParams.set(k, String(obj[k]));
        }
        newUrl = url.href;
      } catch (error) {
        newUrl = String(link);
      }
      return newUrl || '';
    },
    handleJumpLink() {
      // return false;
      // 临时注释 添加banner打开
      // 限时活动统一处理展示逻辑
      // 2024.9.13 K1周年组队活动支付页banner配置
      // 2024.9.19 蚂蚁变异版本组队活动支付页banner配置
      // 2024.9.19 叫我大掌柜中秋储值活动日、韩banner配置
      // 2025.2.10 PNS科技版本组队活动支付页banner配置
      const linkMaps = {
        191: `https://auto-page.${globalConfig.getMainHost()}/pnsvip01/`,
        263: `https://auto-page.${globalConfig.getMainHost()}/mycb02/`,
        285: `https://auto-page.${globalConfig.getMainHost()}/k1longtermtopup/`,
        209: `https://auto-page.${globalConfig.getMainHost()}/dzgwszd_02/`,
        211: `https://auto-page.${globalConfig.getMainHost()}/dzgwszd_01/`
      };
      const currentUTCTime = new Date().toISOString();
      // 限时活动结束时间
      const targetTimeMaps = {
        209: '2024-11-10T14:59:59Z', // 相当于日本时间2024-11-10 23:59:59
        211: '2024-11-10T14:59:59Z', // 相当于韩国时间2024-11-10 23:59:59
        263: '2025-07-18T23:59:59Z',
        285: '2028-12-31T23:59:59Z',
        191: '2040-07-15T23:59:59Z'
      };
      if (
        linkMaps.hasOwnProperty(+this.gameId) &&
        targetTimeMaps.hasOwnProperty(+this.gameId)
      ) {
        // 以UTC+0时间为准，判断当前时间是否在活动结束时间之前
        if (currentUTCTime < targetTimeMaps[+this.gameId]) {
          const activityUrl = linkMaps[+this.gameId];
          openActivity(BANNER_ACTIVITY, activityUrl, {
            language: this.lang,
            ...getGlobalGetLinkParams()
          });
        }
      }
    }
  },
  mounted() {
    if (this.bannerConfigList.length > 1) {
      this.$nextTick(() => {
        this.initSwiper();
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialStore/_dimen.scss';

.banner {
  margin-top: 89px;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  @psetbg ('banner.png', false);
  // 需要banner链接跳转时开启
  cursor: pointer;
  &.dzg-jp {
    background: url($dzgImg + 'banner-jp.jpg') no-repeat;
  }

  &.dzg-kr {
    background: url($dzgImg + 'banner-kr.jpg') no-repeat;
  }

  &.dtmslg-en {
    margin-top: 120px !important;
    background: url($dtmslgImg + 'banner-swiper1.png') no-repeat;
  }

  &.antslg-en {
    background: url($antImg + 'm-mycb02.png') no-repeat;
  }

  &.ztmslg {
    &-en {
      background: url($pnsImg + 'm-rights-en.jpg') no-repeat;
    }
    &-de {
      background: url($pnsImg + 'm-rights-de.jpg') no-repeat;
    }
    &-ko {
      background: url($pnsImg + 'm-rights-ko.jpg') no-repeat;
    }
    &-ru {
      background: url($pnsImg + 'm-rights-ru.jpg') no-repeat;
    }
  }
}

@media screen and (orientation: landscape) {
  .banner {
    margin: 89px auto 0;
    width: 1200px;
    @psetbg ('banner-hen.png', false);

    &.dzg-jp {
      background: url($dzgImg + 'banner-hen-jp.jpg') no-repeat;
    }

    &.dzg-kr {
      background: url($dzgImg + 'banner-hen-kr.jpg') no-repeat;
    }

    &.dtmslg-en {
      background: url($dtmslgImg + 'banner-swiper1-hen.png') no-repeat;
    }

    &.antslg-en {
      background: url($antImg + 'mycb02.png') no-repeat;
    }

    &.ztmslg {
      &-en {
        background: url($pnsImg + 'rights-en.jpg') no-repeat;
      }
      &-de {
        background: url($pnsImg + 'rights-de.jpg') no-repeat;
      }
      &-ko {
        background: url($pnsImg + 'rights-ko.jpg') no-repeat;
      }
      &-ru {
        background: url($pnsImg + 'rights-ru.jpg') no-repeat;
      }
    }
  }
}

//swiper
.banner-swiper {
  width: 750px;
  height: 472px;
  z-index: 0;
  margin-top: 89px;
  // width: 100%;
  // background-size: cover;
  // background-repeat: no-repeat;
  // @psetbg ('banner.png', false);
  // 需要banner链接跳转时开启
  // cursor: pointer;
  .slide-img {
    width: 100%;
    height: 100%;
    &.dtmslg-swiper1 {
      background: url($dtmslgImg + 'banner-swiper1.png') no-repeat;
    }
    &.dtmslg-swiper2 {
      background: url($dtmslgImg + 'm-activity-banner.png') no-repeat;
    }
  }
}

@media screen and (orientation: landscape) {
  .banner-swiper {
    margin: 89px auto 0;
    width: 1200px;
    height: 472px;
    // @psetbg ('banner-hen.png', false);
    .slide-img {
      width: 100%;
      height: 100%;
      &.dtmslg-swiper1 {
        background: url($dtmslgImg + 'banner-swiper1-hen.png') no-repeat;
      }
      &.dtmslg-swiper2 {
        background: url($dtmslgImg + 'activity-banner.png') no-repeat;
      }
    }
  }
}
</style>
<style lang="scss">
// .banner-pagination-bullet {
//   opacity: 1;
//   border: none;
//   background: var(--voucher-banner) !important;

//   &-active {
//     background: var(--voucher-banner-actice) !important;
//   }
// }
.swiper-pagination-bullet {
  background: var(--voucher-banner) !important;
  width: 12px;
  height: 12px;
  opacity: 1;
  margin: 0 5px;
}
.swiper-pagination-bullet-active {
  background: var(--voucher-banner-actice) !important;
}
.swiper-pagination {
  text-align: right;
  bottom: 21px;
}
// .banner-pagination {
//   width: auto !important;
//   float: left;
// }
</style>
